import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestService } from "app/webservice/rest.service";
import { PlatformLocation } from '@angular/common';
import { environment } from "environments/environment";
import { ToastsManager } from "ng2-toastr";

declare let window: any;

@Component({
  selector: 'app-print-barcode',
  templateUrl: './print-barcode.component.html',
  styleUrls: ['./print-barcode.component.css']
})
export class PrintBarcodeComponent implements OnInit {

  public serviceStackUrl;
  public barcodes = [];

  constructor(
    private route: ActivatedRoute, 
    private _restService: RestService, 
    private _toast: ToastsManager,
    platformLocation: PlatformLocation
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';  
    this.route.params.subscribe(params => {
        if (params['RecordKey']) {
          let url = this.serviceStackUrl + "Admin-PrintBarcodePage";
          this._restService.post(url, { ConfigurationName: params['RecordKey'] }).then(response => {
            console.log(response);
            if (response.Success) {
              for (let i = response.BeginningNumber; i <= response.EndningNumber; i++) {
                this.barcodes.push(i);
                window.setTimeout(function(){
                  window.JsBarcode("#barcode-" + i, i, {
                    width:2,
                    height:30
                  });
                }, 100);
              }
              window.setTimeout(() => {
                window.print();
              },500)
            }
          })
        }
      });
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/print-barcode/print-barcode.component.ts